import { Route } from "react-router-dom";
import WhatsAppNumber from "./WhatsAppNumber";
import ListWhatsAppNumber from "./ListWhatsAppNumber";
import UpdateWhatsAppNumber from "./UpdateWhatsAppNumber";
import AddWhatsAppNumber from "./AddWhatsAppNumber";
import WhatsAppDetails from "./WhatsAppDetails";

export default (
  <Route path="WhatsAppAccount" exact element={<WhatsAppNumber />}>
    <Route index element={<ListWhatsAppNumber />} />
    <Route path="Add" element={<AddWhatsAppNumber />} />
    <Route path="edit/:id" element={<UpdateWhatsAppNumber />} />
    <Route path="detail/:id" element={<WhatsAppDetails />} />
  </Route>
);
